(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('bakers', bakers);

    /* @ngInject */
    function bakers() {
        var directive = {
            bindToController: true,
            templateUrl: 'bakers.tpl',
            controller: bakersController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
        }

    }

    /* @ngInject */
    function bakersController () {
    }
})();